import './Backdrop.f821a54eefea061573e69e82fade8838.css';
export default {"backdrop":"_backdrop_105wr_1","fade-in":"_fade-in_105wr_1","flexCenter":"_flexCenter_105wr_1"};